<template>
    <div class="cleanup">

        <div class="title">
            Opgaver uden afdeling
        </div>

        <p>
            <br>
            Oversigten viser opgaver, der ikke er tildelt en afdeling. Det bør rettes op i dit program  til styring af opgaver, så du får den rigtige information at træffe beslutninger på i de forskellige faneblade i proEBITDA. Vær opmærksom på, at ændringen først slår igennem, når data er blevet synkroniseret igen (hver nat).
            <br><br>
        </p>
        
        <vue-good-table
            :columns="columns"
            :rows="rows"
            :search-options="searchOptions"
            :pagination-options="paginationOptions"
            :sort-options="sortOptions"
            :styleClass="styleClass"
            v-if="!loading"
        >
            <div slot="emptystate">
                Ingen data ...
            </div>
            <template slot="table-row" slot-scope="props">
                <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                    {{ props.row.coverage_percent | rounded }} 
                    <div
                        v-if="props.row.coverage_percent !== null"
                        class="coverage-indicator"
                        :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                    />
                </div>
                <div v-else-if="props.column.field == 'case_number'" class="table-column__ordernumber" style="text-align:left;">
                    {{ props.row.case_number }}
                </div>
                <div v-else-if="props.column.field == 'description'" class="table-column__description">
                    {{ props.row.description }}
                </div>
                <div v-else-if="props.column.field == 'customer.name'" class="table-column__customer">
                    <span v-if="props.row.customer">
                        {{ props.row.customer.name }}
                    </span>
                    <span v-else> - </span>
                </div>
                <div v-else-if="props.column.field == 'invoices_total'">
                    {{ props.row.invoices_total | currency}}
                </div>
                <div v-else-if="props.column.field == 'coverage'">
                    {{ props.row.coverage | currency}}
                </div>
                <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                    {{ props.row.coverage_per_hour | currency }} 
                    <div
                        v-if="props.row.coverage_per_hour !== null"
                        class="coverage-indicator"
                        :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                    />
                </div>
                <div v-else-if="props.column.field == 'action'" class="g-table__action" @click="openExternalLink(props.row.external_id)">
                    <i class="fad fa-eye" />
                </div>
                <div v-else-if="props.column.field == 'start_date'">
                    {{ props.row.start_date | moment("DD. MMM YYYY") }}
                </div>
                <div v-else-if="props.column.field == 'type.name'" class="table-column__description" :title="props.row.type ? props.row.type.name : '-'">
                    {{ props.row.type ? props.row.type.name : '-' }}
                </div>
                <div v-else-if="props.column.field == 'minuba_external_id'">
                    <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                        <i class="fas fa-eye"></i>
                    </a>
                </div>
                <div v-else>
                    {{ props.formattedRow[props.column.field] }}
                </div>
            </template>
        </vue-good-table>

        <div class="placeholder" v-else>
            <box-loading height="350" />
        </div>

    </div>
</template>

<script>
import * as settingsService from '@/services/settingsService'

export default {
    data () {
        return {
            loading: true,
            rows: [],
            columns: [
                { label: 'Ordre', field: 'case_number', type: 'number' },
                { label: 'Opgavetype', field: 'type.name', type: 'string' },
                { label: 'Opgave', field: 'description', type: 'string', width: '20%' },
                { label: 'Kunde', field: 'customer.name', type: 'string' },
                { label: 'Startdato', field: 'start_date', type: 'string' }
                /* { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', width: '10%', type: 'number' },
                { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' },
                { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }  */
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'case_number',
                    type: 'asc'
                }
            },
            styleClass: 'vgt-table'
            /* params: {
                'filter[status]': 'unbilled,billed,posted',
                'include': 'customer,type'
            } */
        }
    },
    created () {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' })
        }
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            settingsService.cleanup(params, (response) => {
                this.rows = response.data.projects.rows
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// cleanup.vue?5b96eabc